// this will work in vite build
export default function getConfig() {
  return import.meta.env.envs[window.DP_ENVIRONMENT || 'local'];
}
